/**
 * JavaScript required to implement Skip to Content anchor link due to SWUP library/
 * way SilverStripe rewrites URLs.
 *
 * Skip link is outside the part of the DOM that is switched out dynamically on page
 * transition. Because the anchor link is rewritten to include the current page URL,
 * it no longer acts as an anchor link once the user has navigated away from the first
 * page they land on. This function emulates the same behaviour as an anchor link to get
 * around this.
 */
const SkipToContent = (function () {
  return {
    init: () => {
      const skipLink = document.querySelector('.js-a11y-skip-link')
      if (skipLink) {
        skipLink.addEventListener('click', () => {
          const mainEl = document.querySelector('#a11y-skip--main')
          if (mainEl) {
            mainEl.setAttribute('tabindex', '-1')
            mainEl.focus({ preventScroll: true })
          }
        })
      }
    },
  }
})()

export default SkipToContent
